import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DiscountService } from '../../../services/DiscountService';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '../../../services/Acc_Utility.service';
import * as $ from 'jquery';
import { DiscountEditDialogComponent } from '../discount-edit-dialog/discount-edit-dialog.component';
import { AccessKeyUser } from '../../../models/access-key-user';
@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.css']
})
export class DiscountComponent implements OnInit {
  constructor(private DiscountService: DiscountService,
              private UtilityService: UtilityService,
              public snackBar: MatSnackBar, public dialog: MatDialog) { }
  Discounts: any = {};
  departmentList: any;
  st_department: number = 0;  
  Discount = {
    dicountAmount: "undefined", studentID: "undefined",comment:"Undefined",link:""
  }
  searchKey: string = '0';
  discountAmount: string = '0';
  discountAmountTo: string = '0';
  ngOnInit() {
    this.getBranchId();
    this.DiscountService.getAllDiscount(this.searchKey, this.isBranchId).subscribe(r => {
      this.Discounts = r;
      let fullName = "";
      for (let i = 0; i < this.Discounts.length; i++) {
        if (this.Discounts[i].studentDetails.indexOf(' ولد ') > 0) {
          fullName = this.Discounts[i].studentDetails.split(' ولد ');
          this.Discounts[i].studentDetails = fullName[0];
          if (fullName.length > 1)
            this.Discounts[i].studentFather = fullName[1];
        }
      }
    });
    console.log("Discounts Here: ");
    console.log(this.Discounts);
    this.getDepartments();
  }

  isBranchId: number = -1;
  userId: string = "";
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);    
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId;
    }
  }

  editFee (fee: any): void {
    const dialogRef = this.dialog.open(DiscountEditDialogComponent, {
      width: '1000px',
      data: { studentID: fee["studentID"], discount: fee["discount"], studentDetails: fee["studentDetails"] ,
        comment:fee["comment"],
      link:fee["link"]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.DiscountService.getAllDiscount(this.Discount, this.isBranchId).subscribe(r => this.Discounts = r);
    });
  }

  getDiscounts() {
    this.DiscountService.getDiscount(this.searchKey, this.discountAmount, this.discountAmountTo, this.st_department, this.isBranchId)
      .subscribe(f => {
        this.Discounts = f
        let fullName = "";
        for (let i = 0; i < this.Discounts.length; i++) {
          if (this.Discounts[i].studentDetails.indexOf(' ولد ') > 0) {
          fullName = this.Discounts[i].studentDetails.split(' ولد ');
            this.Discounts[i].studentDetails = fullName[0];
          if (fullName.length > 1)
            this.Discounts[i].studentFather = fullName[1];
        }
        }
      });
    console.log(this.Discounts);
  }

  getDepartments() {
    this.departmentList = this.UtilityService.getDepartments().subscribe(response => {
      console.log(response);
      this.departmentList = response;
    })
  }

  deleteFee(feeID: string) {
    //const dialogRef = this.dialog.open(FeeComponent, {
    //  width: '250px',
    //  data: "آیا مطمین هستید؟"
    //});
    //dialogRef.afterClosed().subscribe(result => {
    //  console.log('The dialog was closed');
    //});
    if (confirm("آیا مطمین هستید؟")) {
      this.DiscountService.deleteDiscount(feeID).subscribe();
      this.snackBar.open(" حذف شد", null, { duration: 5000 });
      $('tr[id="Row' + feeID + '"]').remove();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/discount/discount/discount.component.ts